"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentSettings = void 0;
const utils_1 = require("../../utils");
const lodash_1 = require("lodash");
var AssignmentSettings;
(function (AssignmentSettings) {
    AssignmentSettings.excludedComparisonPaths = ['createdAt', 'modifiedAt', 'migratedAt'];
})(AssignmentSettings || (exports.AssignmentSettings = AssignmentSettings = {}));
(function (AssignmentSettings) {
    function isHomework(assignmentSettings) {
        return assignmentSettings.type === 'homework';
    }
    AssignmentSettings.isHomework = isHomework;
    function isTest(assignmentSettings) {
        return assignmentSettings.type === 'test';
    }
    AssignmentSettings.isTest = isTest;
    function create(assignmentId, ownerId, createdAt, creationSettings) {
        const settings = {
            ...creationSettings,
            createdAt,
            modifiedAt: createdAt,
            ownerId,
            _id: assignmentId,
        };
        return settings;
    }
    AssignmentSettings.create = create;
    function realtimeModeView(settings) {
        if (!settings || settings.type !== 'realtime' || (0, lodash_1.isNil)(settings.currentView)) {
            return undefined;
        }
        return settings.currentView;
    }
    AssignmentSettings.realtimeModeView = realtimeModeView;
    function assignmentIsLinear(settings) {
        return !!(settings && 'isLinear' in settings && settings.isLinear);
    }
    AssignmentSettings.assignmentIsLinear = assignmentIsLinear;
    function isRaiseHandsAllowed(settings) {
        return 'playerSettings' in settings && settings.playerSettings.isRaiseHandAllowed;
    }
    AssignmentSettings.isRaiseHandsAllowed = isRaiseHandsAllowed;
})(AssignmentSettings || (exports.AssignmentSettings = AssignmentSettings = {}));
(function (AssignmentSettings) {
    function updateFields(data) {
        const updateFields = {};
        if (!(0, lodash_1.isNil)(data.ownerId))
            updateFields['ownerId'] = data.ownerId;
        if (!(0, lodash_1.isUndefined)(data.currentView))
            updateFields['currentView'] = data.currentView;
        if (!(0, lodash_1.isUndefined)(data.params))
            updateFields['currentView.params'] = data.params;
        if (!(0, lodash_1.isUndefined)(data.status))
            updateFields['status'] = data.status;
        if (!(0, lodash_1.isUndefined)(data.pincode))
            updateFields['pincode'] = data.pincode;
        if (!(0, lodash_1.isUndefined)(data.nextAssignmentId))
            updateFields['nextAssignmentId'] = data.nextAssignmentId;
        if (!(0, lodash_1.isUndefined)(data.nextAssignmentVersion))
            updateFields['nextAssignmentVersion'] = data.nextAssignmentVersion;
        if (!(0, lodash_1.isUndefined)(data.visibility))
            updateFields['visibility'] = data.visibility;
        if (!(0, lodash_1.isUndefined)(data.gradeModel))
            updateFields['gradeModel'] = data.gradeModel;
        if (data.playerSettings) {
            const { isScreenShared, isSoundEnabled, allowConnectedDevices, isPrepScreenEnabled, allowNewPlayers, autoShowRank, ignoreExclusions, isRaiseHandAllowed, } = data.playerSettings;
            if (!(0, lodash_1.isNil)(isScreenShared))
                updateFields['playerSettings.isScreenShared'] = isScreenShared;
            if (!(0, lodash_1.isNil)(ignoreExclusions))
                updateFields['playerSettings.ignoreExclusions'] = ignoreExclusions;
            if (!(0, lodash_1.isNil)(isSoundEnabled))
                updateFields['playerSettings.isSoundEnabled'] = isSoundEnabled;
            if (!(0, lodash_1.isNil)(allowConnectedDevices))
                updateFields['playerSettings.allowConnectedDevices'] = allowConnectedDevices;
            if (!(0, lodash_1.isNil)(allowNewPlayers))
                updateFields['playerSettings.allowNewPlayers'] = allowNewPlayers;
            if (!(0, lodash_1.isNil)(isPrepScreenEnabled))
                updateFields['playerSettings.isPrepScreenEnabled'] = isPrepScreenEnabled;
            if (!(0, lodash_1.isNil)(autoShowRank))
                updateFields['playerSettings.autoShowRank'] = autoShowRank;
            if (!(0, lodash_1.isNil)(isRaiseHandAllowed))
                updateFields['playerSettings.isRaiseHandAllowed'] = isRaiseHandAllowed;
        }
        if (data.componentSettings) {
            const { spinner } = data.componentSettings;
            if (spinner) {
                const { isSpinning, lastWinner } = spinner;
                if (!(0, lodash_1.isNil)(isSpinning))
                    updateFields['componentSettings.spinner.isSpinning'] = isSpinning;
                if (!(0, lodash_1.isNil)(lastWinner))
                    updateFields['componentSettings.spinner.lastWinner'] = lastWinner;
            }
        }
        const cleaned = (0, utils_1.omitDeepUndefined)(updateFields);
        if (!(0, lodash_1.isNil)(cleaned)) {
            cleaned['modifiedAt'] = Date.now();
        }
        return cleaned;
    }
    AssignmentSettings.updateFields = updateFields;
})(AssignmentSettings || (exports.AssignmentSettings = AssignmentSettings = {}));
//# sourceMappingURL=AssignmentSettings.js.map